var ThermoStatisticsOptions;
(function (ThermoStatisticsOptions) {
    ThermoStatisticsOptions["MIN"] = "temperatureMin";
    ThermoStatisticsOptions["MAX"] = "temperatureMax";
    ThermoStatisticsOptions["AVG"] = "temperatureAvg";
})(ThermoStatisticsOptions || (ThermoStatisticsOptions = {}));
export default ThermoStatisticsOptions;
